import { AxiosRequestConfig } from 'axios'
import { IBaseQueryParameters } from './index.js'

export interface IRequestConfig extends AxiosRequestConfig {
  params?: IBaseQueryParameters
}
